import { getCurrentEmployee, getDefaultRFQID } from '@/utils/shared'

export const ModelRFQ = function () {
  const employee = getCurrentEmployee()
  return {
    rfqid: getDefaultRFQID(),
    customerCompanyID: null,
    rfqTypeID: 2,
    baxEmployeeID: employee && employee.id,
    priorityID: 1,
    customerContactID: null,
    customerCompanyDetailID: null,
    observation: ''
  }
}
export const ModelRFQ1 = function () {
  return {
    rfqid: '',
    qty: 1,
    partID: null,
    observation: null
  }
}
// Using for creating RFQ3
export const ModelRFQ3ByRFQ2 = function () {
  return {
    id: null,
    chosen: false,
    rfqid: null,
    quoteDate: new Date(),
    partID: null,
    partSN: '',
    qty: 1,
    conditionID: null,
    price: null,
    currencyID: null,
    traceabilityCompanyID: null,
    tagInfoCompanyID: null,
    tagDate: null,
    releaseID: null
  }
}
// Using for creating RFQ3
export const ModelRFQ3Stock = function () {
  return {
    id: null,
    rfqid: null,
    quoteDate: new Date(),
    partID: null,
    partSN: '',
    qty: 1,
    conditionID: null,
    price: null,
    currencyID: null,
    traceabilityCompanyID: null,
    tagInfoCompanyID: null,
    tagDate: null,
    releaseID: null,
    stockID: null,
    supplyDate: ''
  }
}
